import { Link, NavLink } from "react-router-dom";
import Reveal from "./reveal";
import styled from "styled-components";
const STATIC_URL = process.env.REACT_APP_STATIC_URL;

const ScheduleLink = () => {
  const imgSrc = STATIC_URL + "/call-to-action-bg.jpg";
  return (
    <Wrapper>
      <div
        id="call-to-action"
        style={{
          backgroundImage: "url(" + `${STATIC_URL}/call-to-action-bg.jpg` + ")",
          backgroundPosition: "bottom",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          padding: 0,
          position: "relative",
        }}
      >
        <div className="cta-text">*SCHEDULE A FREE ESTIMATE*</div>
        <Link className="cta-btn" id="" to="/contact">
          Call To Action
        </Link>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  /* Call To Action Section
--------------------------------*/
    display: flex;
    flex: 1;
    flex-grow: 1;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    width: 90%;
  

  #call-to-action .cta-text {
    color: #fff;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    padding-top: 20px;
  }

  #call-to-action .cta-btn {
    font-family: "Montserrat", sans-serif;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 1px;
    display: inline-block;
    padding: 8px 28px;
    border-radius: 25px;
    margin: 10px 40px 10px 40px;
    border: 2px solid #fff;
    color: #fff;
    text-align: center;
  }

  #call-to-action .cta-btn:hover {
    background: #18d26e;
    border: 2px solid #18d26e;
  }
`;
export default ScheduleLink;
